import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const SideMenuContext = createContext();

export const SideMenuProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openMenu = () => setIsOpen(true);
    const closeMenu = () => setIsOpen(false);
    const toggleMenu = () => setIsOpen((prev) => !prev);

    return (
        <SideMenuContext.Provider value={{ isOpen, openMenu, closeMenu, toggleMenu }}>
            {children}
        </SideMenuContext.Provider>
    );
};

SideMenuProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

// eslint-disable-next-line react-refresh/only-export-components
export const useSideMenu = () => useContext(SideMenuContext);